import React from "react";

export type IncidentViewMode = "pending" | "resolved" | "all";

const VIEW_TABS: { id: IncidentViewMode; label: string; icon: string }[] = [
  { id: "pending", label: "Pendientes", icon: "fa-clock" },
  { id: "resolved", label: "Resueltas", icon: "fa-circle-check" },
  { id: "all", label: "Todas", icon: "fa-list" },
];

type IncidentViewTabsProps = {
  value: IncidentViewMode;
  onChange: (mode: IncidentViewMode) => void;
};

const IncidentViewTabs = ({ value, onChange }: IncidentViewTabsProps) => {
  return (
    <>
      <style>{`
        .incidents-view-tabs {
          display: flex;
          gap: 4px;
          width: 100%;
          min-width: 0;
          box-sizing: border-box;
          padding: 6px;
          margin-bottom: 16px;
          background: linear-gradient(135deg, #495057 0%, #343a40 100%);
          border-radius: 12px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }
        .incidents-view-tab {
          flex: 1 1 0;
          min-width: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 4px;
          min-height: 44px;
          padding: 6px 4px;
          border: none;
          border-radius: 8px;
          background: transparent;
          color: rgba(255, 255, 255, 0.55);
          font-size: 11px;
          font-weight: 500;
          line-height: 1.15;
          cursor: pointer;
          outline: none;
          transition: background 0.2s ease, color 0.2s ease;
        }
        .incidents-view-tab-label {
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .incidents-view-tab:hover:not(.is-active) {
          background: rgba(255, 255, 255, 0.08);
          color: rgba(255, 255, 255, 0.9);
        }
        .incidents-view-tab.is-active {
          background: rgba(255, 255, 255, 0.14);
          color: #ffffff;
          font-weight: 600;
        }
        .incidents-view-tab:focus-visible {
          outline: 2px solid rgba(255, 255, 255, 0.5);
          outline-offset: 2px;
        }
        .incidents-view-tab-icon {
          font-size: 12px;
          line-height: 1;
          opacity: 0.85;
        }
        .incidents-view-tab.is-active .incidents-view-tab-icon {
          opacity: 1;
        }
        @media (min-width: 576px) {
          .incidents-view-tabs {
            gap: 6px;
            padding: 8px;
          }
          .incidents-view-tab {
            flex-direction: row;
            gap: 8px;
            min-height: 40px;
            padding: 8px 12px;
            font-size: 13px;
          }
        }
      `}</style>

      <div
        className="incidents-view-tabs"
        role="tablist"
        aria-label="Filtrar incidencias"
      >
        {VIEW_TABS.map((tab) => {
          const isActive = value === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={isActive}
              aria-controls="incidents-table-panel"
              id={`incidents-tab-${tab.id}`}
              className={`incidents-view-tab${isActive ? " is-active" : ""}`}
              onClick={() => onChange(tab.id)}
            >
              <i className={`fa ${tab.icon} incidents-view-tab-icon`} aria-hidden />
              <span className="incidents-view-tab-label">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </>
  );
};

export default IncidentViewTabs;
